import { t } from '@lingui/macro';
import { z } from 'zod';
import { SkillTypeEnum } from '../../../utils/skill-type-enum';

export const BaseSkillSchema = z.object(
  {
    type: SkillTypeEnum,
    code: z.string().trim().min(1),
    referential_id: z.string().trim().uuid(),
    name: z.string().trim().min(1),
  },
  {
    required_error: t`Le nom est obligatoire.`,
    invalid_type_error: t`Le nom n'est pas valide.`,
  }
);
export type BaseSkillSchemaT = z.infer<typeof BaseSkillSchema>;

const withLevelSchema = z.discriminatedUnion('hasLevel', [
  z.object({
    hasLevel: z.literal(true),
    level: z.number({ coerce: true }),
  }),
  z.object({
    hasLevel: z.literal(false),
    level: z.null(),
  }),
]);

const withInterestSchema = z.discriminatedUnion('hasInterest', [
  z.object({
    hasInterest: z.literal(true),
    interest: z.number({ coerce: true }),
  }),
  z.object({
    hasInterest: z.literal(false),
    interest: z.null(),
  }),
]);

export const SkillSchema = z.object({
  skill: BaseSkillSchema,
  level: withLevelSchema,
  interest: withInterestSchema,
});

export type SkillSchemaT = z.infer<typeof SkillSchema>;

export const UpdateSkillSchema = z.object({
  id: z.string().trim().uuid(),
  skill: BaseSkillSchema,
  level: z.string().nullable(),
  interest: z.string().nullable(),
  favorite: z.string().nullable(),
  description: z.string().nullable(),
});

export type UpdateSkillSchemaT = z.infer<typeof UpdateSkillSchema>;

type Nullable<T = {}> = {
  [K in keyof T]: T[K] | null;
};

export type SkillSchemaNullableT = Nullable<SkillSchemaT>;
export type UpdateSkillSchemaNullableT = Nullable<UpdateSkillSchemaT>;
